import Component from 'ShopUi/models/component';

export default class SkipToMainContent extends Component {

    private static readonly CONSTANTS = {
        CONTAINER_TAG: 'main',
        SKIP_TO_MAIN_LINK_ID: 'skip-to-main-link',
        FOCUS_DELAY_MS: 300
    };

    private link: HTMLElement;
    private container: HTMLElement;

    protected init(): void {
      this.container = document.getElementsByTagName(SkipToMainContent.CONSTANTS.CONTAINER_TAG)?.[0] as HTMLElement;
      if (this.container) {
          this.container.setAttribute('tabindex', '-1');
      }

      this.link = document.getElementById(SkipToMainContent.CONSTANTS.SKIP_TO_MAIN_LINK_ID);

      this.addSkipToMainContentEventListener();
    }

    private readonly addSkipToMainContentEventListener = (): void => {
      if (this.link) {
        this.link.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Enter' && this.container) {
            e.preventDefault();
            this.removeFocusOfLink();
            setTimeout(() => this.container.focus(), SkipToMainContent.CONSTANTS.FOCUS_DELAY_MS);
          }
        });

        this.link.addEventListener('focus', () => {
          document.addEventListener('mousemove', this.removeFocusOfLink);
        });

        this.link.addEventListener('blur', () => {
          document.removeEventListener('mousemove', this.removeFocusOfLink);
        });
      }
    }

    private readonly removeFocusOfLink = () => {
      this.link.blur();
    }

    protected readyCallback(): void {
    }

}
